export default __webpack_public_path__ + "ceeccaf03adce42a383fb6cd47004812.png";